var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditBtn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.58263 2.50233L11.498 4.41766C11.628 4.54766 11.628 4.75899 11.498 4.88899L3.4113 12.9757C3.36063 13.0037 3.28463 13.0457 3.2333 13.0737L0.766632 13.627C0.746632 13.6337 0.719965 13.6403 0.693299 13.6403C0.606632 13.6403 0.526632 13.6003 0.459965 13.5403C0.379965 13.4603 0.346632 13.3403 0.373299 13.2337L0.929965 10.7517C0.957965 10.7003 0.984632 10.6517 1.0133 10.6003L9.11063 2.50233C9.2413 2.37166 9.45196 2.37166 9.58263 2.50233ZM13.6266 2.57299C13.64 2.67299 13.6066 2.77299 13.5333 2.84633L12.436 3.94966C12.306 4.08033 12.0946 4.08033 11.964 3.95033L10.05 2.03633C9.9193 1.90566 9.91996 1.69433 10.0506 1.56433L11.1533 0.466327C11.2266 0.392994 11.3266 0.359661 11.4266 0.372994C11.46 0.379661 12.2466 0.486328 12.88 1.11966C13.5133 1.75299 13.62 2.53966 13.6266 2.57299Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditBtn);
export default __webpack_public_path__ + "static/media/edit-btn.5f2a318fcb9bab9a741fcfb1e84a88be.svg";
export { ForwardRef as ReactComponent };